import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { Spring } from "react-spring/renderprops";
import MyLoader from "./loader";

import axios from "axios";
import config from "../config.json";

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      results: [], // results data frmo json feed
      resultsShown: 20, // number results to show initially
      loading: true
    };
  }

  //
  // get the data after the component mounts
  // Here we're getting the Results Summary items from the feed
  //
  async componentDidMount() {
    const { data: results } = await axios.get(config.apiResultsEndPoint, {
      crossDomain: true
    }); // async operation - returns json data -> rename to questions
    this.setState({ results, loading: false });
  }

  //
  // find the result based on it's id
  //

  getResult(id) {
    return this.state.results.find(m => m.nid === id);
  }
  //
  // Create a summary list that gets displayed based on the
  // choices
  // chosenResults =
  //  {result: '<result id>',
  //   prompts: [<array or choices that pointed to that result>]
  //   }
  //

  listSummary = resultItem => {
    var markup = "";
    var item = {};
    if ((item = this.getResult(resultItem.result))) {
      markup += '<div class="summary-content">' + item.summary + "</div></div>";
    }
    return ReactHtmlParser(markup);
  };

  formatPrompts(prompts) {
    var promptString = "<ul>";
    for (var i = 0; i < prompts.length; i++) {
      promptString += "<li>" + ReactHtmlParser(prompts[i]) + "</li>";
    }
    return promptString + "</ul>";
  }

  getNextPrompt(chosenResults) {
    return this.formatPrompts(
      chosenResults[this.state.resultsShown + 1].prompts
    );
  }
  moreButton = chosenResults => {
    return (
      <Spring
        delay={800}
        from={{ opacity: 0, marginTop: -50 }}
        to={{ opacity: 1, marginTop: 0 }}
      >
        {props => (
          <div className="row more-area" style={props}>
            <div className="small-12 large-6 columns">
              <h3>For the following concerns:</h3>
              {ReactHtmlParser(this.getNextPrompt(chosenResults))}
            </div>
            <div className="small-12 large-5 columns">
              <button
                className="moreButton"
                onClick={() => this.showMore(chosenResults.length)}
              >
                Show Summary
              </button>
            </div>
          </div>
        )}
      </Spring>
    );
  };

  showMore = total => {
    if (this.state.resultsShown <= total) {
      this.setState(state => ({ resultsShown: state.resultsShown + 1 }));
    }
  };

  render() {
    if (this.state.loading) return <MyLoader />;

    const { chosenResults = [] } = this.props;

    //
    // get the summaries to show.
    // The show more button says to load another if there's more to show.
    //
    var noResults = '\
    <div class="summary-wrapper">\
    <div class="no-results column large-6 large-offset-4">\
    <p>You have not selected any issues</p>\
    </div></div>';
    var showItems = chosenResults
      .slice(0, this.state.resultsShown + 1)
      .map((item, index) => (
        <div className="summary-wrapper" key={index}>
          {this.listSummary(item)}
        </div>
      ));
    return (
      <Spring
        from={{ opacity: 0, marginTop: -50 }}
        to={{ opacity: 1, marginTop: 0 }}
      >
        {props => (
          <section className="row column recommend" style={props}>
            <h2>Recommendations</h2>
            <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
              {({ opacity }) => (
                <div style={{ opacity }}>
                  {showItems.length
                    ? showItems
                    : chosenResults.length
                    ? "Loading..."
                      : ReactHtmlParser(noResults)
              }
                </div>
              )}
            </Spring>
            {this.state.resultsShown + 1 < chosenResults.length &&
              this.moreButton(chosenResults)}
          </section>
        )}
      </Spring>
    );
  }
}

export default Summary;
